import { BASE_URL } from '../constants';
import { errorHandling, errorHandler } from '../utils/errorHandling';
import { getItem } from '../utils/localStore';

class placeOrderApi {
    static doPlaceOrder(data) {
        const TOKEN = getItem('auth_token');
        let isError = false;

        // let placeorderdata={
        //     ext_id: data.ext_id,
        //     mpid: data.mpid,
        //     account_id: data.account_id,
        //     requested_amount: data.requested_amount,
        //     buying_power: data.buying_power,
        //     attestation_to_rules_5130_and_5131: data.attestation_to_rules_5130_and_5131,
        //     dsp: data.dsp,
        // }

        try{
            const ajaxRequestHeaders = new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Authorization': TOKEN
            });
            let body = {
                method: 'POST',
                headers: ajaxRequestHeaders,
                body: JSON.stringify(data)
            }
            return fetch(BASE_URL + '/orders', body).then(response => {
                isError = errorHandling(response);
                return response.json();
            }).catch(error => {
                if (error && !isError) {
                    errorHandler(error);
                }
                return error;
            });
        }catch(err){
        }
    }
}

export default placeOrderApi;